import AuthService from '../services/AuthService';
import db from '@/config/dexie';

const APP_STORAGE_KEY = 'OMNI_WEBAPP_USER';

export interface AuthState {
  currentUser: {
    objectId: string,
    name: string,
    retailer: {
      objectId: string,
    },
    sessionToken: string,
  };
}

export const AuthModule = {
  state: {
    currentUser: window.localStorage.getItem(APP_STORAGE_KEY) &&
        JSON.parse(window.localStorage.getItem(APP_STORAGE_KEY) as any),
  },
  mutations: {
    async setCurrentUser(state: any, user: any) {
      if (user) {
        const storageUser = { objectId: user.objectId, retailer: user.retailer };
        window.localStorage.setItem(APP_STORAGE_KEY, JSON.stringify(storageUser));
        (db as any).currentUser.put(user);
      } else {
        window.localStorage.removeItem(APP_STORAGE_KEY);
      }
      state.currentUser = user;
    },
    logout(state: any) {
      state.currentUser = undefined;
      window.localStorage.removeItem(APP_STORAGE_KEY);
      (db as any).currentUser.clear();
    },
  },
  actions: {
    async syncCurrentUserFomDB(context: any) {
      const user = await getCurrentUser();
      context.commit('setCurrentUser', user);
    },
    async logout(context: any) {
      context.commit('logout');
      context.commit('setRetailer', null);
      context.commit('setRoles', null);
    },
    async login(context: any, payload: {email: string, password: string}): Promise<any> {
      return AuthService.login(payload.email, payload.password).then((res: any) => {
        context.commit('setCurrentUser', res);
      });
    },
  },
};

/**
 * Retrieve the currentUser from IndexDB.
 */
async function getCurrentUser() {
  return new Promise((resolve) => {
    (db as any).currentUser.toArray((res: any) => {
      resolve(res && res.length && res[0] || null);
    });
  });
}
